module.exports = __webpack_public_path__ + "img/ai-code-editor-img.6b094ee8.png";